import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Platform }         from 'ionic-angular';
import { AngularFire, AuthProviders,
    AuthMethods} from 'angularfire2';
import firebase from 'firebase';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';

import { Facebook, NativeStorage } from 'ionic-native';

declare var window: any;
var FB_APP_ID: number = 1215993065141821;
export interface login {
    setup();
    login();
    logout();
    getUserDetails();
}

@Injectable()
export class FaceBookService {
    fbapp: login;     
    userStatus: any = null;
    constructor(
        public http: Http,
        private platform: Platform,
        public af: AngularFire,
        public location: Location
    ) {
        var that = this;
        console.log('Hello UserService Provider');
        this.platform.ready().then(Response => {
            if (this.platform.is('cordova')) {
                this.fbapp = new loginNative(that.handleStatus.bind(that));
            } else {
                this.fbapp = new loginJavaScript(that.handleStatus.bind(that));
            }
        });
    }
    
    ///---------------------------------------------------------------------
    setup() {
        this.fbapp.setup();
    };
    login() {
        this.fbapp.login();
    };
    logout() {
        this.fbapp.logout();
    };
    getUserDetails() { this.fbapp.getUserDetails();}
    //--------------------------------------------------------------------
    
    handleStatus(response) {
        //this.userStatus = response;
        console.log(response);
        if (response.status === 'connected') {
            // the user is logged in and has authenticated your
            // app, and response.authResponse supplies
            // the user's ID, a valid access token, a signed
            // request, and the time the access token 
            // and signed request each expire
            var uid = response.authResponse.userID;
            var accessToken = response.authResponse.accessToken;
            //this.getUserProfile(uid);
            this.loginAngularFire(accessToken);
            this.getUserDetails();

        } else if (response.status === 'not_authorized') {
            // the user is logged in to Facebook, 
            // but has not authenticated your app
            this.userStatus = response;
        } else {
            // the user isn't logged in to Facebook.
            this.userStatus = response;
        }
    }
    
    loginAngularFire(accessToken) {
        let creds = firebase.auth.FacebookAuthProvider.credential(accessToken)
        this.af.auth.login(creds, {
            provider: AuthProviders.Facebook,
            method: AuthMethods.OAuthToken,
            //remember: 'default',
            scope: ['email','public_profile']
        }).then((success) => {
            this.userStatus = success;
            console.log("Firebase success: " + JSON.stringify(success));            
        })
            .catch((error) => {
                this.userStatus = null;
                console.log("Firebase failure: " + JSON.stringify(error));                
            });
    }
}   

export class loginJavaScript implements login{
    constructor(public cb: any) {
        this.setup();
    }
    setup() {
        var that = this;
        var appId = '' + FB_APP_ID;
        console.log(window.location.host);
        if (window.location.host.indexOf('neelsoftware.ddns.net') >= 0)
            appId = '268020610277496';
        window.FB.init({
            appId: appId,
            xfbml: true,
            version: 'v2.8'
        });
        window.FB.AppEvents.logPageView();
        window.FB.Event.subscribe('auth.statusChange', function (response) {
            that.cb(response);
        });
        that.getStatus();
    }
    login() {
        var that = this;
        window.FB.getLoginStatus(function (response) {
            if (response.status === 'connected') { that.cb(response); return; }
            window.FB.login(function (response) {
                console.log(response);
            });
        });
    }
    logout() {
        window.FB.logout();
    }
    getStatus() {
        var that = this;
        window.FB.getLoginStatus(function (response) {
            that.cb(response);
        });
    }
    getUserDetails() {
        window.FB.api('/me', function (response) { console.log(response);});
    }
}
export class loginNative implements login {
    constructor(public cb: any) {
        this.setup();
    }
    login() {
        var that = this;
        let permissions = new Array();
        permissions = ["public_profile"];

        Facebook.login(permissions)
            .then(function (response) {
                let userId = response.authResponse.userID;
                that.cb(response);
            }, function (error) {
                console.log(error);
            });
    }
    setup() {
        Facebook.browserInit(FB_APP_ID, "v2.8");
        this.getStatus();
    }   
    logout() {
        Facebook.logout()
    }
    getStatus() {
        var that = this;
        window.FB.getLoginStatus(function (response) {
            that.cb(response);
        });
    }
    getUserDetails() {
        window.FB.api('/me', function (response) { console.log(response); });
    }
}


// WEBPACK FOOTER //
// ./src/app/feature/loginModule/providers/facebook-provider.ts